import Highlight from './Highlight.jsx';

export default Highlight;
